import { Card } from 'antd';
import Styles from './assets/styles.scss';
import {
	ICardGridProps,
	ICardMetaProps,
	ICardProps,
	ICardSizes,
	ICardTabListProps
} from './entities';

const BCCard = (props: ICardProps) => {
	Styles;

	const {
		actions,
		activeTabKey,
		headStyle,
		bodyStyle,
		bordered,
		cover,
		defaultActiveTabKey,
		extra,
		hoverable,
		loading,
		size,
		title,
		type,
		onTabChange,
		children,
		className,
		style,
		seleniumId
	} = props;

	return (
		<Card
			className={className}
			actions={actions}
			activeTabKey={activeTabKey}
			styles={{
				header: headStyle,
				body: bodyStyle
			}}
			bordered={bordered}
			cover={cover}
			defaultActiveTabKey={defaultActiveTabKey}
			extra={extra}
			hoverable={hoverable}
			loading={loading}
			size={size}
			title={title}
			type={type}
			onTabChange={onTabChange}
			style={style}
			data-selenium-id={seleniumId}
		>
			{children}
		</Card>
	);
};

export default BCCard;

const { Meta, Grid } = Card;

export {
	Grid as BCCardGrid,
	Meta as BCCardMeta,
	ICardGridProps,
	ICardMetaProps,
	ICardProps,
	ICardSizes,
	ICardTabListProps
};
